function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as i } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import { LitElement as b } from "../../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import y from "../../../../packages/web-components/src/components/date-picker/base/gator/datepicker.gator.scss.js";
import f from "../../../../packages/web-components/src/tokens/primitive.tokens.scss.js";
import m from "../../../../packages/web-components/src/tokens/semantic.tokens.scss.js";
import D from "../../../../packages/web-components/src/components/button/gator/button.gator.scss.js";
import { customElement as _ } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { state as S } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/state.js";
import "../../../icon-button/gator/icon-button.gator.js";
import "../../../button/gator/button.gator.js";
import "../../../selector/gator/selector.gator.js";
import { SELECTOR_TYPE as d } from "../../year-month-selector/year-month-selector.gator.js";
import { NjcDatepicker as w } from "../datepicker.js";
import { KEY_CONSTANTS as n } from "../../../../consts/key-constants.js";
import { msg as c } from "../../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/init/install.js";
import { localized as k } from "../../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/internal/localized-decorator.js";
import "../../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/init/runtime.js";
import { unsafeCSS as u } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var M = Object.defineProperty,
  x = Object.getOwnPropertyDescriptor,
  p = function p(e, t, a, r) {
    for (var o = r > 1 ? void 0 : r ? x(t, a) : t, s = e.length - 1, l; s >= 0; s--) (l = e[s]) && (o = (r ? l(t, a, o) : l(o)) || o);
    return r && o && M(t, a, o), o;
  },
  Y = function (e) {
    return e.CALENDAR = "calendar", e.MONTHS = "months", e.YEARS = "years", e;
  }(Y || {});
var h = /*#__PURE__*/function (_w) {
  function h() {
    var _this;
    _classCallCheck(this, h);
    _this = _callSuper(this, h, arguments), _this._currentView = "calendar", _this.previousScrollTop = 0;
    return _this;
  }
  _inherits(h, _w);
  return _createClass(h, [{
    key: "render",
    value: function render() {
      return i(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <div class=\"gator-datepicker\"\n                role=\"dialog\"\n                aria-modal=\"true\"\n                aria-label=", "\n                lang=", "\n                @keydown=", ">\n                ", "\n                ", "\n            </div>\n        "])), "".concat(this.currentMonthName, " ").concat(this._contextYear), this.locale, this.handleDatepickerKeydown, this.headerMarkup, this.currentViewMarkup);
    }
  }, {
    key: "updated",
    value: function updated(e) {
      _superPropGet(h, "updated", this, 3)([e]), e.has("_contextMonth") && this.shiftFocusToCalendarGrid();
    }
  }, {
    key: "shiftFocusToCalendarGrid",
    value: function shiftFocusToCalendarGrid() {
      var _this2 = this;
      setTimeout(function () {
        var e;
        (e = _this2.renderRoot.querySelector('ngc-selector[tabindex="0"]')) == null || e.focus();
      }, 0);
    }
  }, {
    key: "handleDatepickerKeydown",
    value: function handleDatepickerKeydown(e) {
      this._currentView === "calendar" ? this.handleCalendarViewKeydown(e) : this.handleSelectionDialogKeydown(e);
    }
  }, {
    key: "headerMarkup",
    get: function get() {
      return i(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            <div class=\"gator-datepicker-header\">\n                <div class=\"gator-datepicker-header-title\">\n                    <ngc-icon-button\n                        id=\"prev-month\"\n                        size=\"small\"\n                        aria-label=\"", "\"\n                        icon-name=\"chevron-left\"\n                        @click=", ">\n                    </ngc-icon-button>\n                    <div class=\"button-group\" aria-live=\"polite\">\n                            <button\n                                role=\"combobox\"\n                                id=\"month-combobox\"\n                                aria-label=", "\n                                aria-haspopup=\"dialog\"\n                                aria-expanded=", "\n                                aria-autocomplete=\"none\"\n                                aria-controls=\"month-selectors\"\n                                class='gator-button gator-button_base gator-button_medium'\n                                @click=", "\n                                @keydown=", ">\n                                <span class=\"gator-button-text\">", "</span>\n                            </button>\n                            <button\n                                role=\"combobox\"\n                                id=\"year-combobox\"\n                                aria-label=", "\n                                aria-haspopup=\"dialog\"\n                                aria-expanded=", "\n                                aria-autocomplete=\"none\"\n                                aria-controls=\"year-selectors\"\n                                class='gator-button gator-button_base gator-button_medium'\n                                @click=", "\n                                @keydown=", ">\n                                <span class=\"gator-button-text\">", "</span>\n                            </button>\n                    </div>\n                    <ngc-icon-button\n                        id=\"next-month\"\n                        size=\"small\"\n                        aria-label=\"", "\"\n                        icon-name=\"chevron-right\"\n                        @click=", ">\n                    </ngc-icon-button>\n                </div>\n            </div>\n        "])), c("Previous Month"), this.handlePreviousMonthClicked, c("Current Month"), this._currentView === "months", this.handleMonthClick, this.handleYearMonthComboboxKeydown, this.currentMonthName, c("Current Year"), this._currentView === "years", this.handleYearClick, this.handleYearMonthComboboxKeydown, this._contextYear, c("Next Month"), this.handleNextMonthClicked);
    }
  }, {
    key: "handlePreviousMonthClicked",
    value: function handlePreviousMonthClicked() {
      this._contextDate = new Date(this._contextYear, this._contextMonth - 1, 1), this._currentView = "calendar";
    }
  }, {
    key: "handleMonthClick",
    value: function handleMonthClick() {
      this._currentView === "months" ? this._currentView = "calendar" : this._currentView = "months";
    }
  }, {
    key: "handleYearClick",
    value: function handleYearClick() {
      this._currentView === "years" ? this._currentView = "calendar" : (this._currentView = "years", this.scrollToSelectedYear());
    }
  }, {
    key: "handleNextMonthClicked",
    value: function handleNextMonthClicked() {
      this._contextDate = new Date(this._contextYear, this._contextMonth + 1, 1), this._currentView = "calendar";
    }
  }, {
    key: "handleYearMonthComboboxKeydown",
    value: function handleYearMonthComboboxKeydown(e) {
      if (e.key === n.TAB && !e.shiftKey && this._currentView !== "calendar") {
        e.preventDefault();
        var a = this.renderRoot.querySelector('ngc-year-month-selector[tabindex="0"]');
        a == null || a.focus();
      }
    }
  }, {
    key: "currentViewMarkup",
    get: function get() {
      switch (this._currentView) {
        case "calendar":
          return this.calendarMarkup;
        case "months":
          return this.getYearOrMonthSelectorGrid(d.MONTH);
        case "years":
          return this.getYearOrMonthSelectorGrid(d.YEAR);
        default:
          return null;
      }
    }
  }, {
    key: "calendarMarkup",
    get: function get() {
      return i(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                <table class=\"gator-datepicker-table\" role=\"grid\">\n                    <thead role=\"rowgroup\" class=\"gator-datepicker-table-header\">\n                        <tr role=\"row\">\n                            ", "\n                        </tr>\n                    </thead>\n                    <tbody role=\"rowgroup\"\n                        class=\"gator-datepicker-table-body gator-datepicker-table-body-dates\">\n                        ", "\n                    </tbody>\n                </table>\n                ", "\n            "])), this.daysOfWeekMarkup, this.getDatesMarkup, this.footerMarkup);
    }
  }, {
    key: "daysOfWeekMarkup",
    get: function get() {
      return i(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                ", "\n            "])), this._localizedDaysOfWeek.map(function (e) {
        return i(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                    <div role=\"columnheader\">\n                        ", "\n                    </div>"])), e);
      }));
    }
  }, {
    key: "getDatesMarkup",
    get: function get() {
      var _this3 = this;
      var e = this._contextDays,
        t = [];
      for (var a = 0; a < e.length; a += 7) t.push(e.slice(a, a + 7));
      return i(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n                    ", "\n                </div>\n            "])), t.map(function (a) {
        return i(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n                        <tr role=\"row\">\n                            ", "\n                        </tr>\n                    "])), a.map(function (_ref) {
          var r = _ref.date;
          return i(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n                                <ngc-selector\n                                    role=\"gridcell\"\n                                    ?current=", "\n                                    ?selected=", "\n                                    ?disabled=", "\n                                    type=", "\n                                    tabindex='", "'\n                                    @keydown=", "\n                                    @select=", "\n                                    data-value=", "\n                                >\n                                    ", "\n                                </ngc-selector>\n                            "])), _this3.isSameDate(r, _this3._todaysDate), _this3.setSelectorSelected(r), _this3.isDateOutsideMinMax(r), _this3.setSelectorType(r), _this3.isSameDate(r, _this3._contextDate) ? 0 : -1, _this3.handleDateKeydown, function (o) {
            return _this3.handleDateClick(o, r);
          }, r.getDate(), r.getDate());
        }));
      }));
    }
  }, {
    key: "handleDateKeydown",
    value: function handleDateKeydown(e) {
      switch (e.key) {
        case n.UP:
          e.preventDefault(), this.setNewContextDateAndShiftFocus(-7);
          break;
        case n.DOWN:
          e.preventDefault(), this.setNewContextDateAndShiftFocus(7);
          break;
        case n.LEFT:
          e.preventDefault(), this.setNewContextDateAndShiftFocus(-1);
          break;
        case n.RIGHT:
          e.preventDefault(), this.setNewContextDateAndShiftFocus(1);
          break;
      }
    }
  }, {
    key: "handleDateClick",
    value: function handleDateClick(e, t) {
      this._contextDate = t, this.range ? this.handleRangeSelection(t) : (e.target.selected ? this.clearSelection() : this.setSelectedDate(t), this.dispatchDateChangeEvent());
    }
  }, {
    key: "handleRangeSelection",
    value: function handleRangeSelection(e) {
      this._startDate ? this._startDate && !this._endDate ? e < this._startDate ? this.setRangeStart(e) : this.setRangeEnd(e) : this._startDate && this._endDate && (e < this._startDate ? this.setRangeStart(e) : e > this._endDate ? this.setRangeEnd(e) : (this.clearSelection(), this.setRangeStart(e))) : this.setRangeStart(e), this.dispatchDateRangeChangeEvent();
    }
  }, {
    key: "setSelectorType",
    value: function setSelectorType(e) {
      if (this.range) {
        if (this._startDate && this._endDate && this.isSameDate(this._startDate, this._endDate)) return "base";
        if (this.isSameDate(e, this._startDate)) return "range-start";
        if (this.isSameDate(e, this._endDate)) return "range-end";
        if (this.isDateInRange(e)) return "range-in-between";
      }
      return e.getMonth() === this._contextDate.getMonth() ? "base" : "inactive";
    }
  }, {
    key: "setSelectorSelected",
    value: function setSelectorSelected(e) {
      return this.range ? this.isDateInRange(e) : this.isSameDate(e, this._selectedDate);
    }
  }, {
    key: "setNewContextDateAndShiftFocus",
    value: function setNewContextDateAndShiftFocus(e) {
      var t;
      this._contextDate = new Date(this._contextDate.getFullYear(), this._contextDate.getMonth(), this._contextDate.getDate() + e), (t = this.getSelectorByDate(this._contextDate)) == null || t.focus();
    }
  }, {
    key: "getSelectorByDate",
    value: function getSelectorByDate(e) {
      return this.renderRoot.querySelector("ngc-selector[data-value=\"".concat(e.getDate(), "\"]:not([type=\"inactive\"])"));
    }
  }, {
    key: "handleCalendarViewKeydown",
    value: function handleCalendarViewKeydown(e) {
      var t, a;
      if (e.key === n.TAB) {
        var r = this.renderRoot.querySelector("#prev-month"),
          o = this.renderRoot.querySelector("#done-button");
        e.shiftKey ? ((t = this.shadowRoot) == null ? void 0 : t.activeElement) === r && (o.focus(), e.preventDefault()) : ((a = this.shadowRoot) == null ? void 0 : a.activeElement) === o && (r.focus(), e.preventDefault());
      }
    }
  }, {
    key: "getYearOrMonthSelectorGrid",
    value: function getYearOrMonthSelectorGrid(e) {
      var _this4 = this;
      var a = e === d.YEAR ? this._years : this._localizedMonths,
        r = [];
      for (var o = 0; o < a.length; o += 3) r.push(a.slice(o, o + 3));
      return i(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n                <div role=\"dialog\"\n                    class=\"gator-datepicker-year-month-selectors\"\n                    id=\"", "-selectors\"\n                    aria-label=\"", "\"\n                    @keydown=", ">\n                    <table class=\"gator-datepicker-table\" role=\"grid\">\n                        <tbody class=\"gator-datepicker-table-body gator-datepicker-table-body-year-month\" @scroll=", ">\n                            ", "\n                        </tbody>\n                    </table>\n                    ", "\n                </div>\n            "])), e, e === d.YEAR ? c("Year Selection") : c("Month Selection"), this.handleSelectionDialogKeydown, this.onYearSelectorScroll, r.map(function (o) {
        return i(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n                                <tr>\n                                    ", "\n                                </tr>\n                            "])), o.map(function (_ref2) {
          var s = _ref2.dataValue,
            l = _ref2.selectorText;
          return i(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n                                        <ngc-year-month-selector\n                                            data-value=", "\n                                            tabindex=", "\n                                            ?current=", "\n                                            ?selected=", "\n                                            @select=", "\n                                            @keydown=", "\n                                            >\n                                            ", "\n                                        </ngc-year-month-selector>\n                                    "])), s, _this4.yearMonthSelectorTabindex(e, s), _this4.isYearMonthSelectorCurrent(e, s), _this4.isYearMonthSelectorSelected(e, s), function () {
            return _this4.handleYearMonthSelectorClick(s, e);
          }, function (g) {
            return _this4.handleYearMonthSelectorKeyDown(g, s);
          }, l);
        }));
      }), this.footerMarkup);
    }
  }, {
    key: "handleSelectionDialogKeydown",
    value: function handleSelectionDialogKeydown(e) {
      var t, a;
      switch (e.key) {
        case n.TAB:
          var r = this.renderRoot.querySelector('ngc-year-month-selector[tabindex="0"]'),
            o = this.renderRoot.querySelector("#done-button");
          e.shiftKey ? ((t = this.shadowRoot) == null ? void 0 : t.activeElement) === r && (o.focus(), e.preventDefault()) : ((a = this.shadowRoot) == null ? void 0 : a.activeElement) === o && (r.focus(), e.preventDefault());
          break;
        case n.ESCAPE:
          e.preventDefault(), e.stopPropagation();
          var s = this._currentView === "years" ? this.renderRoot.querySelector("#year-combobox") : this.renderRoot.querySelector("#month-combobox");
          this._currentView = "calendar", s.focus();
          break;
      }
    }
  }, {
    key: "isYearMonthSelectorCurrent",
    value: function isYearMonthSelectorCurrent(e, t) {
      return e === "year" ? this._todaysDate.getFullYear() === t : this._todaysDate.getMonth() === t;
    }
  }, {
    key: "isYearMonthSelectorSelected",
    value: function isYearMonthSelectorSelected(e, t) {
      return e === "year" ? this._contextYear === t : this._contextMonth === t;
    }
  }, {
    key: "yearMonthSelectorTabindex",
    value: function yearMonthSelectorTabindex(e, t) {
      var _this5 = this;
      if (e === "year") {
        var a = this._years.some(function (s) {
            return s.dataValue === _this5._contextYear;
          }),
          r = this._years[0].dataValue === t,
          o = this._contextYear === t;
        return a ? o ? 0 : -1 : r ? 0 : -1;
      }
      return this._contextMonth === t ? 0 : -1;
    }
  }, {
    key: "handleYearMonthSelectorClick",
    value: function handleYearMonthSelectorClick(e, t) {
      var a;
      t === "month" ? this._contextDate = new Date(this._contextYear, e, 1) : this._contextDate = new Date(e, this._contextMonth, 1), this._currentView = "calendar", (a = this.renderRoot.querySelector("#".concat(t, "-combobox"))) == null || a.focus();
    }
  }, {
    key: "handleYearMonthSelectorKeyDown",
    value: function handleYearMonthSelectorKeyDown(e, t) {
      switch (e.key) {
        case n.UP:
          e.preventDefault(), this.shiftFocusToYearMonthSelector(t - 3);
          break;
        case n.DOWN:
          e.preventDefault(), this.shiftFocusToYearMonthSelector(t + 3);
          break;
        case n.LEFT:
          e.preventDefault(), this.shiftFocusToYearMonthSelector(t - 1);
          break;
        case n.RIGHT:
          e.preventDefault(), this.shiftFocusToYearMonthSelector(t + 1);
          break;
      }
    }
  }, {
    key: "shiftFocusToYearMonthSelector",
    value: function () {
      var _shiftFocusToYearMonthSelector = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        var t, a;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              t = this.renderRoot.querySelector("ngc-year-month-selector[data-value=\"".concat(e, "\"]"));
              if (!t) {
                _context.next = 5;
                break;
              }
              t.focus();
              _context.next = 12;
              break;
            case 5:
              a = this._years.length ? this._years[0].dataValue : new Date().getFullYear();
              _context.t0 = e < a;
              if (!_context.t0) {
                _context.next = 12;
                break;
              }
              this.loadMoreYearsBefore();
              _context.next = 11;
              return this.updateComplete;
            case 11:
              this.shiftFocusToYearMonthSelector(e);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function shiftFocusToYearMonthSelector(_x) {
        return _shiftFocusToYearMonthSelector.apply(this, arguments);
      }
      return shiftFocusToYearMonthSelector;
    }()
  }, {
    key: "onYearSelectorScroll",
    value: function () {
      var _onYearSelectorScroll = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
        var r, o, t, a, s, l;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              t = e.target, a = t.scrollTop > this.previousScrollTop;
              if (!(this.previousScrollTop = t.scrollTop, a && t.scrollHeight - t.scrollTop === t.clientHeight)) {
                _context2.next = 5;
                break;
              }
              this.loadMoreYearsAfter();
              _context2.next = 12;
              break;
            case 5:
              if (!(!a && t.scrollTop === 0 && ((o = (r = this.shadowRoot) == null ? void 0 : r.activeElement) == null ? void 0 : o.tagName) !== "NGC-YEAR-MONTH-SELECTOR")) {
                _context2.next = 12;
                break;
              }
              s = t.scrollHeight;
              this.loadMoreYearsBefore();
              _context2.next = 10;
              return this.updateComplete;
            case 10:
              l = t.scrollHeight;
              t.scrollTop = l - s;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function onYearSelectorScroll(_x2) {
        return _onYearSelectorScroll.apply(this, arguments);
      }
      return onYearSelectorScroll;
    }()
  }, {
    key: "loadMoreYearsAfter",
    value: function loadMoreYearsAfter() {
      var e = this._years.length ? this._years[this._years.length - 1].dataValue : new Date().getFullYear(),
        t = this.loadMoreYearsBatch(e + 1);
      this._years = [].concat(_toConsumableArray(this._years), _toConsumableArray(t)), this.requestUpdate();
    }
  }, {
    key: "loadMoreYearsBefore",
    value: function loadMoreYearsBefore() {
      var e = this._years.length ? this._years[0].dataValue : new Date().getFullYear(),
        t = this.loadMoreYearsBatch(e - this._yearsBatchSize, e - 1);
      this._years = [].concat(_toConsumableArray(t), _toConsumableArray(this._years)), this.requestUpdate();
    }
  }, {
    key: "scrollToSelectedYear",
    value: function () {
      var _scrollToSelectedYear = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var e;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.updateComplete;
            case 2:
              e = this.renderRoot.querySelector("ngc-year-month-selector[selected]");
              e == null || e.scrollIntoView({
                behavior: "auto",
                block: "center"
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function scrollToSelectedYear() {
        return _scrollToSelectedYear.apply(this, arguments);
      }
      return scrollToSelectedYear;
    }()
  }, {
    key: "footerMarkup",
    get: function get() {
      return i(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n            <div class=\"gator-datepicker-footer\">\n                <ngc-button id=\"clear-button\" variant='base' @click=", ">", "</ngc-button>\n                <ngc-button id=\"today-button\" variant='base' @click=", " ?disabled=", ">", "</ngc-button>\n                <ngc-button id=\"done-button\" variant='base' @click=", ">", "</ngc-button>\n            </div>\n        "])), this.handleClearClick, c("Clear"), this.handleTodayClick, this.isTodayDisabled(), c("Today"), this.handleDoneClick, c("Done"));
    }
  }, {
    key: "handleClearClick",
    value: function handleClearClick() {
      this.clearSelection(), this._contextDate = this._todaysDate, this._currentView = "calendar", this.dispatchChangeEvent(), this.dispatchEvent(new CustomEvent("done"));
    }
  }, {
    key: "handleTodayClick",
    value: function handleTodayClick() {
      this._contextDate = this._todaysDate, this.range ? (this.setRangeStart(this._todaysDate), this.setRangeEnd(this._todaysDate)) : this.setSelectedDate(this._todaysDate), this._currentView = "calendar", this.dispatchChangeEvent();
    }
  }, {
    key: "handleDoneClick",
    value: function handleDoneClick() {
      this.dispatchEvent(new CustomEvent("done"));
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.range && this._startDate && (this._contextDate = this._startDate), !this.range && this._selectedDate && (this._contextDate = this._selectedDate);
    }
  }]);
}(w);
h.shadowRootOptions = _objectSpread(_objectSpread({}, b.shadowRootOptions), {}, {
  delegatesFocus: !0
});
h.styles = [u(y), u(f), u(m), u(D)];
p([S()], h.prototype, "_currentView", 2);
h = p([_("ngc-datepicker"), k()], h);
export { Y as DATE_PICKER_VIEW, h as NgcDatepicker };